import React, { useEffect, useRef, useState } from 'react';
import classes from './HomePage.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LinkCard from './LinkCard';
import ButtonRoundedEdges from '../../UI/Buttons/ButtonRoundedEdges';
import * as PathRouter from '../../../models/PathRoute'
import Soon from '../../UI/Soon';
import LearningTrackingCard from './Card/LearningTrackingCard';
import { onKeyDown } from '../../../service';
import { UserActivityEnum } from '../../../models/UserActivityEnum';
import Permissions from '../../Permissions';
import { getCoursesData } from '../../../store/discipline-action';
import HomePageBanner from './HomePageBanner';
import { messagesApi } from '../../../utils';
import { throwApiError } from '../../lms-shared/store/error-handling-actions';
import { ObjectTypeNamesEnum } from '../../../models/ObjectTypeEnum';
import { selectDisciplinesCurrentYear } from '../../../store/discipline-slice';
import { fetchCoursesData } from '../../../store/course-actions';

const HomePage = () => {

    const { direction, lang, texts } = useSelector(state => state.translate);
    const { applicationId, homeUrl, studentImg, studentStyle } = useSelector(state => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state));
    const { courses } = useSelector(state => state.courses);

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { applictionName } = useParams();

    const [bannerData, setBannerData] = useState()


    const componentMounted = useRef(true);

    useEffect(() => {
        if (uiData && uiData.bannerMessageTypeId && lang) {
            if (!disciplines && applicationId)
                dispatch(getCoursesData());
            const data = {
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId,
                targetObjects: [
                    { type: ObjectTypeNamesEnum.ConstUserGroup },
                ],
                includeMessageTypesIds: [uiData?.bannerMessageTypeId],
                lang: lang
            }

            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessagecontentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessagecontentMessagesFilterRange " + error.message, level: 2, component: "MessagesPage", line: 45 }))
                } else {
                    if (componentMounted.current) {
                        if (resdata.length > 0 && resdata[0].contents && resdata[0].contents.length > 0) {
                            const data = JSON.parse(resdata[0].contents[0].content)
                            setBannerData(data)
                        }
                    }
                }
            })
        }
    }, [applicationId, uiData, lang])

    useEffect(() => {
        if (!courses.length && applicationId) {
            dispatch(fetchCoursesData())
        }
    }, [applicationId])

    const HomePageCards = {
        cardsDetails: [
            {
                key: "1",
                title: texts.dashboardMyCourses,
                textLink: texts.dashboardAllMyCourses,
                content: [
                    <ButtonRoundedEdges key="ButtonRoundedEdges_1" onClick={() => navigate(`${homeUrl}/${PathRouter.COURSES}/${PathRouter.NEW}`)} bgColor="#76E8E9" color="black"> {texts.createNew}</ButtonRoundedEdges>,
                    <ButtonRoundedEdges key="ButtonRoundedEdges_2" onClick={() => navigate(`${homeUrl}/${PathRouter.COURSES}`)} bgColor="#76E8E9" color="black"> {texts.addLessons}</ButtonRoundedEdges>,
                    <ButtonRoundedEdges key="ButtonRoundedEdges_4" onClick={() => navigate(`${homeUrl}/${PathRouter.COURSES}`)} bgColor="#76E8E9" color="black"> {texts.dashboardEditCourse}</ButtonRoundedEdges>
                ]
            },
            {
                key: "2",
                title: texts.dashboardLearningMonitoring,
                textLink: texts.dashboardLearningMonitoring,
                content: courses &&
                    <LearningTrackingCard contentList={courses} paramurl1={"learningTracking"} paramurl2={"learningTrackingMain"} />,
                color: '#AAFFB2'
            },
            {
                key: "3",
                title: texts.dashboardAuxiliaryMaterialsLibrary,
                textLink: texts.dashboardLibrary,
                content: [
                    <ButtonRoundedEdges key="ButtonRoundedEdges_3" onClick={() => navigate(`${PathRouter.MATERIAL_LIBRARY}`)} bgColor="linear-gradient(131.8deg, #141938 4.41%, #2A315F 87.11%)" color="white"> {texts.dashboardFindLibrary}</ButtonRoundedEdges>
                ]
            },
            {
                key: "4",
                title: texts.dashboardCurriculum,
                textLink: texts.dashboardCurriculum,
                content: disciplines?.filter(c => c.active).slice(0, 3).map(c =>
                    <ButtonRoundedEdges key={c.courseId} onClick={() => navigate(`${PathRouter.CURRICULUM}/${c.id}`)} bgColor="linear-gradient(180deg, #94CFEC 0%, #74C2EC 100%)" color="black">{c.name}</ButtonRoundedEdges>
                )
            },
            {
                key: "5",
                title: texts.dashboardTrainingRoom,
                textLink: texts.dashboardTrainingRoom,
                // content: sortedTRainingRoomData &&
                //     <TrainingRoomCard contentList={sortedTRainingRoomData} />,
            },
            {
                key: "6",
                title: texts.dashboardForum,
                textLink: texts.dashboardAuxiliaryMaterialsLibraryMore,
                // content: [
                //     // <ButtonRoundedEdges key="ButtonRoundedEdges_3" onClick={() => navigate(`${PathRouter.MATERIAL_LIBRARY}`)} bgColor="linear-gradient(131.8deg, #141938 4.41%, #2A315F 87.11%)" color="white"> {texts.myProjects}</ButtonRoundedEdges>
                // ],
            },
            {
                key: "8",
                title: texts.adminManegment,
                textLink: texts.adminManegment,
                content: [
                    <Permissions key="adminManegment_ButtonRoundedEdges_1" activityType={UserActivityEnum.LearningSupervision}>
                        <ButtonRoundedEdges onClick={() => navigate(`${PathRouter.ADMIN}/${PathRouter.GUIDE}`)} bgColor="linear-gradient(131.8deg, #BE35A2 4.41%, #9445B6 87.11%)" color="white"> {texts.monitoringSchools}</ButtonRoundedEdges>
                    </Permissions>,
                    <Permissions key="adminManegment_ButtonRoundedEdges_2" activityType={UserActivityEnum.EditCourse}>
                        <ButtonRoundedEdges onClick={() => navigate(`${PathRouter.ADMIN}/${PathRouter.DISCIPILINES}`)} bgColor="linear-gradient(131.8deg, #BE35A2 4.41%, #9445B6 87.11%)" color="white"> {texts.professionsTitle}</ButtonRoundedEdges>
                    </Permissions>,
                    <Permissions key="adminManegment_ButtonRoundedEdges_3" activityType={UserActivityEnum.AddAlarms}>
                        <ButtonRoundedEdges onClick={() => navigate(`${PathRouter.ADMIN}/${PathRouter.MESSAGES}`)} bgColor="linear-gradient(131.8deg, #BE35A2 4.41%, #9445B6 87.11%)" color="white"> {texts.messages}</ButtonRoundedEdges>
                    </Permissions>
                ],
                permissionActivityType: UserActivityEnum.Any
            }
        ]
    }

    const clickStudent = () => {
        window.open(`${window.config.studentSideOriginalUrl}/${applictionName}`, '_blank', 'noopener,noreferrer')
    }

    return (
        <div className={`${classes[direction]} ${classes.BackImgWarrper}`}>
            <div className={classes.BackImgTop}>
                {bannerData && <HomePageBanner {...bannerData}></HomePageBanner>}
            </div>
            <div className={classes.BackImgButtom}></div>
            {uiData && <div className={classes.HomePage}>
                <div className={classes.WrapLinks}>
                    {HomePageCards && HomePageCards.cardsDetails.map((card, i) =>
                        // supervisor 
                        uiData.mainScreenCards && uiData.mainScreenCards[card.key].display &&
                        <Permissions key={i} activityType={card.permissionActivityType} >
                            <div className={classes.CardWrapper} key={card.key}>
                                <LinkCard
                                    title={card.title}
                                    icon={uiData?.mainScreenCards[card.key].icon}
                                    style={uiData?.mainScreenCards[card.key].style}
                                    textLink={card.textLink}
                                    onClick={() => navigate(uiData?.mainScreenCards[card.key].goTo)}>
                                    {card.content}
                                </LinkCard>
                                {uiData?.mainScreenCards[card.key].soon &&
                                    <Soon top="-11px" position="absolute" height="241px" width="242px" borderRadius="8px"></Soon>
                                }
                            </div>
                        </Permissions>

                    )}
                    <div className={classes.StudentWrapper}>
                        <div className={classes.Student} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickStudent)} onClick={clickStudent} style={{ background: studentStyle?.bg || "#73DED8", color: studentStyle?.clr || "unset" }}>{texts.student}</div>
                        <div className={classes.StudentImg} style={{ backgroundImage: `url(${studentImg})` }}></div>
                    </div>
                </div>
                {/* <div className={classes.AplicationImg} style={{ backgroundImage: `url(${dashboardImg}` }}></div> */}
            </div>}
        </div>
    )
}

export default HomePage;